import { trackCubeCustomEvent } from '../tracking/trackingLayer';

const Portal = () => import('@linusborg/vue-simple-portal')
  .then(module => module.Portal);

export default {
  template: '#pangv-template',

  props: {
    pangvPreis: {
      required: false,
      type: String,
    },
    schwarzpreis: {
      required: true,
      type: String,
    },
    rotpreis: {
      required: false,
      type: String,
    },
  },
  components: {
    Portal,
  },
  created() {
    document.addEventListener('ents-pangv-tooltip:tooltip-show', this.trackModalEventOpen);
  },
  destroyed() {
    document.removeEventListener('ents-pangv-tooltip:tooltip-show', this.trackModalEventOpen);
  },
  methods: {
    openLayer() {
      this.$refs.pangvModal.addEventListener('ents-modal:close', this.onLayerClose);
      this.$refs.pangvModal.classList.remove('hidden');
      this.$refs.pangvModal.show();
      this.trackModalEvent('open');
    },
    onLayerClose() {
      this.trackModalEvent('close');
      this.$refs.pangvModal.removeEventListener('ents-modal:close', this.onLayerClose);
    },
    trackModalEventOpen() {
      this.trackModalEvent('open');
    },
    trackModalEvent(action) {
      trackCubeCustomEvent(`pangv_layer_${action}`, {
        event_category: 'pangv_layer',
        is_interaction_event: true,
        event_type: 'click',
      });
    },
  },
};
